import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const MyTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f5f3ff',
      100: '#ede9fe',
      200: '#ddd6fe',
      300: '#c4b5fd',
      400: '#a78bfa',
      500: '#6750A4',
      600: '#5640A0',
      700: '#4c408d',
      800: '#3a307a',
      900: '#282066',
      950: '#161053',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        surface: {
          0: '#FFFFFF',
          50: '#FFFBFE',
          100: '#F7F2FA',
          200: '#F3EDF7',
          300: '#E8DEF8',
          400: '#CAC4D0',
          500: '#79747E',
          600: '#49454F',
          700: '#1D1B20',
          800: '#1D1B20',
          900: '#1D1B20',
          950: '#141218',
        },
      },
      dark: {
        primary: {
          color: '#D0BCFF',
          contrastColor: '#381E72',
          hoverColor: '#B69DF8',
          activeColor: '#EADDFF',
        },
        surface: {
          0: '#0F0D13',
          50: '#141218',
          100: '#1D1B20',
          200: '#211F26',
          300: '#4A4458',
          400: '#49454F',
          500: '#938F99',
          600: '#CAC4D0',
          700: '#E6E0E9',
          800: '#E6E0E9',
          900: '#E6E0E9',
          950: '#FFFBFE',
        },
      },
    },
  },
  components: {
    menu: {
      list: {
        padding: '0.5rem',
      },
      item: {
        padding: '0.75rem 1rem',
      },
    },
  },
});
